import { IDeviceActionRequestPayload } from '@components/DeviceActionModal/types';
import api from '@services/api';
import { message } from 'antd';

const postDeviceActions = async (payload: IDeviceActionRequestPayload) => {
  return api.post('/service-proxy/actions', payload);
};

export const useSendDeviceActions = () => {
  const handleDeviceActions = async (payload: IDeviceActionRequestPayload) => {
    try {
      return postDeviceActions(payload);
    } catch (error: any) {
      message.error(error?.response?.data);
      return undefined;
    }
  };
  return {
    handleDeviceActions,
  };
};
